import { systemConstants } from '_constants';
import { userService } from '_services';
import { alertActions, userActions } from '_actions';
//import { history } from '_helpers';

export const systemActions = {
    getRenewNotifications,
    renewTerms
   
};



function getRenewNotifications(callback=null) {
    const params = {
        request: 'renew_notification',
      };

    return dispatch => {
        dispatch(request());
        userService.userRequest(params)
        .then(
            data => {
                if (data.success) {
                    console.log("Got renew_notifications");
                    console.log(data)
                    dispatch(success(data));
                    if (callback !== null) {
                        callback(true, data)
                    }
                } else {
                    const msg = data.message ? data.message : "Unknown Server Error. Please try again"
                    dispatch(failure(msg.toString()));
                    dispatch(alertActions.error(msg.toString()));
                    if (callback) { callback(false, msg) }
                }
            },
            error => {
                if (error.status === 401) {
                    console.log("renew_notification: fatal error")
                    dispatch(userActions.endSession(error))    
                }
            }
        )
    };
    
    function request()       { return { type: systemConstants.RENEW_NOTIFICATION_REQUEST} }
    function success(data)   { return { type: systemConstants.RENEW_NOTIFICATION_SUCCESS, data } }
    function failure(error)  { return { type: systemConstants.RENEW_NOTIFICATION_FAILURE, error } }
}

function renewTerms(callback=null) {
    const params = {
        request: 'terms_renewed',
      };

    return dispatch => {
        dispatch(request());
        userService.userRequest(params)
        .then(
            data => {
                if (data.success) {
                    console.log("Got terms_renewed");
                    console.log(data)
                    dispatch(success(data));
                    if (callback !== null) {
                        callback(true, data)
                    }
                } else {
                    const msg = data.message ? data.message : "Unknown Server Error. Please try again"
                    dispatch(failure(msg.toString()));
                    dispatch(alertActions.error(msg.toString()));
                    if (callback) { callback(false, msg) }
                }
            },
            error => {
                if (error.status === 401) {
                    console.log("terms_renewed: fatal error")
                    dispatch(userActions.endSession(error))    
                }
            }
        )
    };
    
    function request()       { return { type: systemConstants.TERMS_RENEWED_REQUEST} }
    function success(data)   { return { type: systemConstants.TERMS_RENEWED_SUCCESS, data } }
    function failure(error)  { return { type: systemConstants.TERMS_RENEWED_FAILURE, error } }
}



